import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "On Going Course Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date ", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date ", -1)
const _hoisted_15 = { class: "col-md-3 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "row mt-1 w-100 m-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_20 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "table-responsive mt-3" }
const _hoisted_28 = { class: "table table-borderless gy-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      rowspan: "2"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      rowspan: "2"
    }, " Training Institute "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      rowspan: "2"
    }, " Courses "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      rowspan: "2"
    }, " Batches "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid  !important","text-align":"center"},
      colspan: "3"
    }, " Trainee Attendance ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center"} }, " Target "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center"} }, " Actual "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center"} }, " % "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center"} }, " Average "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center"} }, " Below 80% ")
  ])
], -1)
const _hoisted_30 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }
const _hoisted_31 = {
  colspan: "9",
  style: {"border":"1px solid  !important"}
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }, " Total ", -1)
const _hoisted_36 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_37 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_38 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_39 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_40 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_41 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_42 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_43 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_44 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_45 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_46 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_47 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_48 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_49 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_50 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_51 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_52 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }, " Grand Total ", -1)
const _hoisted_54 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_55 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_56 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_57 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_58 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_59 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_60 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_61 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.batch.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.batch.start_date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      name: "start_date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.batch.end_date,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      name: "end_date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingProviderNotice())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_16
                ])
              ])
            ]),
            (_ctx.showCourseNotice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                        title: "Download Xlse",
                        "data-v-54b12dc8": "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                      }, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Download PDF",
                        "data-v-54b12dc8": "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                      }, _hoisted_24),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                        title: "Print",
                        "data-v-54b12dc8": "",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                      }, _hoisted_26)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("table", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (info, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createElementVNode("tr", _hoisted_30, [
                              _createElementVNode("th", _hoisted_31, [
                                (index == 'public_entity')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Public Institutions"))
                                  : _createCommentVNode("", true),
                                (index == 'private_entity')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Private Entity(BBSME && PKSF)"))
                                  : _createCommentVNode("", true),
                                (index == 'industry_entity')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Industry Association"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (inf, ind) => {
                              return (_openBlock(), _createElementBlock("tr", { key: ind }, [
                                (ind === 'total')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_35,
                                      _createElementVNode("th", _hoisted_36, _toDisplayString(inf?.institute_count), 1),
                                      _createElementVNode("th", _hoisted_37, _toDisplayString(Number(inf?.course_count).toLocaleString()), 1),
                                      _createElementVNode("th", _hoisted_38, _toDisplayString(Number(inf?.batch_count).toLocaleString()), 1),
                                      _createElementVNode("th", _hoisted_39, _toDisplayString(Number(inf?.target_trainee).toLocaleString()), 1),
                                      _createElementVNode("th", _hoisted_40, _toDisplayString(Number(inf?.enrolled_trainee).toLocaleString()), 1),
                                      _createElementVNode("th", _hoisted_41, _toDisplayString((inf?.trainee_percentage).toFixed(2)), 1),
                                      _createElementVNode("th", _hoisted_42, _toDisplayString((inf?.attendance_trainee_average).toFixed(2)), 1),
                                      _createElementVNode("th", _hoisted_43, _toDisplayString((inf?.below_attendance_trainee_percentage).toFixed(
                                    2
                                  )), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("td", _hoisted_44, _toDisplayString(inf?.entity_name), 1),
                                      _createElementVNode("td", _hoisted_45, _toDisplayString(inf?.institute_count), 1),
                                      _createElementVNode("td", _hoisted_46, _toDisplayString(Number(inf?.course_count).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_47, _toDisplayString(Number(inf?.batch_count).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_48, _toDisplayString(Number(inf?.target_trainee).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_49, _toDisplayString(Number(inf?.enrolled_trainee).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_50, _toDisplayString((inf?.trainee_percentage).toFixed(2)), 1),
                                      _createElementVNode("td", _hoisted_51, _toDisplayString((inf?.attendance_trainee_average).toFixed(2)), 1),
                                      _createElementVNode("td", _hoisted_52, _toDisplayString((inf?.below_attendance_trainee_percentage).toFixed(
                                    2
                                  )), 1)
                                    ], 64))
                              ]))
                            }), 128))
                          ], 64))
                        }), 128)),
                        _createElementVNode("tr", null, [
                          _hoisted_53,
                          _createElementVNode("th", _hoisted_54, _toDisplayString(Number(
                              _ctx.data?.public_entity?.total?.institute_count +
                              _ctx.data?.private_entity?.total?.institute_count +
                              _ctx.data?.industry_entity?.total?.institute_count
                            ).toLocaleString()), 1),
                          _createElementVNode("th", _hoisted_55, _toDisplayString(Number(
                              _ctx.data?.public_entity?.total?.course_count +
                              _ctx.data?.private_entity?.total?.course_count +
                              _ctx.data?.industry_entity?.total?.course_count
                            ).toLocaleString()), 1),
                          _createElementVNode("th", _hoisted_56, _toDisplayString(Number(
                              _ctx.data?.public_entity?.total?.batch_count +
                              _ctx.data?.private_entity?.total?.batch_count +
                              _ctx.data?.industry_entity?.total?.batch_count
                            ).toLocaleString()), 1),
                          _createElementVNode("th", _hoisted_57, _toDisplayString(Number(
                              _ctx.data?.public_entity?.total?.target_trainee +
                              _ctx.data?.private_entity?.total?.target_trainee +
                              _ctx.data?.industry_entity?.total?.target_trainee
                            ).toLocaleString()), 1),
                          _createElementVNode("th", _hoisted_58, _toDisplayString(Number(
                              _ctx.data?.public_entity?.total?.enrolled_trainee +
                              _ctx.data?.private_entity?.total?.enrolled_trainee +
                              _ctx.data?.industry_entity?.total?.enrolled_trainee
                            ).toLocaleString()), 1),
                          _createElementVNode("th", _hoisted_59, _toDisplayString((((_ctx.data?.public_entity?.total?.enrolled_trainee +
                                _ctx.data?.private_entity?.total?.enrolled_trainee +
                                _ctx.data?.industry_entity?.total?.enrolled_trainee) / (_ctx.data?.public_entity?.total?.target_trainee +
                                  _ctx.data?.private_entity?.total?.target_trainee +
                                  _ctx.data?.industry_entity?.total?.target_trainee)) * 100).toFixed(
                                    2
                                  )), 1),
                          _createElementVNode("th", _hoisted_60, _toDisplayString((((_ctx.data?.public_entity?.total?.attendance_trainee +
                                _ctx.data?.private_entity?.total?.below_attendance_trainee +
                                _ctx.data?.industry_entity?.total?.below_attendance_trainee) / (_ctx.data?.public_entity?.total?.enrolled_trainee
                                  +
                                  _ctx.data?.private_entity?.total?.enrolled_trainee +
                                  _ctx.data?.industry_entity?.total?.enrolled_trainee)) * 100).toFixed(
                                    2
                                  )), 1),
                          _createElementVNode("th", _hoisted_61, _toDisplayString((((_ctx.data?.public_entity?.total?.below_attendance_trainee +
                                _ctx.data?.private_entity?.total?.below_attendance_trainee +
                                _ctx.data?.industry_entity?.total?.below_attendance_trainee) / (_ctx.data?.public_entity?.total?.enrolled_trainee
                                  +
                                  _ctx.data?.private_entity?.total?.enrolled_trainee +
                                  _ctx.data?.industry_entity?.total?.enrolled_trainee)) * 100).toFixed(
                                    2
                                  )), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}